import React, { useState } from "react";
import { createCheckoutSession } from "../services/paymentService"; // Import the payment service

const PaymentPage = ({ emissionId, email, amount }) => {
  const [paidAmount, setPaidAmount] = useState(amount || 20); // New state for paidAmount
  const [error, setError] = useState(""); // State for error message
  const [loading, setLoading] = useState(false); // State for loading spinner

  const handlePayment = async () => {
    if (paidAmount <= 0) {
      setError("The payment amount must be greater than 0.");
      return;
    }

    setError(""); // Clear any previous errors
    setLoading(true); // Show loading spinner

    try {
      const sessionUrl = await createCheckoutSession(emissionId, email, amount, paidAmount); // Use paidAmount
      window.location.href = sessionUrl; // Redirect to Stripe checkout
    } catch (error) {
      console.error(error.message);
      setError("Failed to initiate payment. Please try again.");
    } finally {
      setLoading(false); // Hide loading spinner
    }
  };

  const handleAmountChange = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value) && value > 0) {
      setPaidAmount(value); // Update paidAmount only if the input is valid
      setError(""); // Clear error if the input is valid
    } else {
      setPaidAmount(""); // Clear the input if the value is invalid
      setError("Pls enter the amount greater than USD 1");
    }
  };

  return (
<div className="container d-flex flex-column justify-content-center align-items-center mt-5 mb-5">    
  
  {amount ? 
    <div className="mb-2">Calculated Amount: <strong>$ {amount.toFixed(2)}</strong></div>
    : <div className="mb-2">Estimated Amount: From $20 upwards (Estimate your impact and offset directly based on hours flown — $10 per hour for round-trip Business Class or $7 per hour for round-trip Economy Class.)</div>
  }    

  <div className="mb-3 d-flex align-items-center">
    <label htmlFor="paidAmount" className="form-label me-3 mb-0">
      Payment Amount $
    </label>
    <input
      type="number"
      id="paidAmount"
      className="form-control"
      value={paidAmount}
      onChange={handleAmountChange}
      min="0.01"
      step="0.01"
      style={{ maxWidth: "150px" }}
    />
  </div>

  {error && <p className="text-danger">{error}</p>}

  <button
    className="btn btn-primary p-3"
    onClick={handlePayment}
    disabled={loading || !paidAmount || paidAmount <= 0}
  >
    {loading ? (
      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    ) : (
      "Pay & View Reports"
    )}
  </button>
</div>

  );
};

export default PaymentPage;